import styled from '@emotion/styled';
import { RacemapColors } from '@racemap/utilities/consts/common';
import type { FC, PropsWithChildren } from 'react';

interface Props {
  show?: boolean;
}

export const NotificationBadge: FC<PropsWithChildren<Props>> = ({ show = true, children }) => {
  return (
    <Container>
      {children}
      {show && <Circle />}
    </Container>
  );
};

const Container = styled.div`
  position: relative;
`;

const Circle = styled.div`
  background-color: ${RacemapColors.PaleBlue};
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
`;
